// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-container{display:flex;flex-direction:column;position:absolute;top:0;right:0;bottom:0;left:0;flex-grow:1;flex-shrink:1;padding:8px}.wl-container>.wl-container-scroll{flex:1;flex-grow:1;flex-shrink:1}.wl-container>.wl-container-scroll>.el-scrollbar__wrap{overflow-x:hidden}.wl-container>.wl-container-main{position:relative;flex:1;flex-grow:1;flex-shrink:1;overflow:hidden}", ""]);
// Exports
module.exports = exports;
